<template>
    <div>
        <div class="flex items-start justify-between mb-4">
            <div class="tone_wrapper">
                <div class="tone_box">
                    <img src="/icons/dead-weight.svg" />
                </div>
                <div>
                    <p class=" text-gray-500 text-sm">TOTAL WEIGHT</p>
                    <p><b class=" text-3xl font-semibold">{{ fleets && fleets.totalWeight }}</b> tonnes</p>
                </div>
            </div>
        </div>
        <!-- {{ filterUndispatchedFleet  }} -->
        <div class="flex flex-wrap justify-between">
            <div class="flex flex-wrap w-full justify-between">
                <div class="places_wrapper mb-4">
                    <div class="pl-0 flex items-center font-semibold">
                        Origin
                    </div>

                    <div class="px-2 mt-1 bg-primary-lighterblue text-sm py-2">
                        {{
                            currentLocation
                                ? currentLocation.location.locationName
                                : "No Location Selected"
                        }},
                        <br />
                        <p class=" text-gray-500 mt-1 text-sm">{{ currentLocation ? currentLocation.location.address :
                            "" }}</p>
                    </div>
                </div>

                <div class="mb-4 places_wrapper">
                    <div class="flex items-center font-semibold">
                        Destination
                    </div>
                    <div class="px-0 pl-0 mt-1">
                        <el-select multiple v-model="payload.destination" placeholder="Select Destinations">
                            <el-option v-for="location in locations" :key="location.id" :label="location.locationName"
                                :value="location.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
            </div>

            <div class="w-full flex flex-wrap justify-between gag-4">
                <div class="w-full md:w-[48%]">
                    <label class="mb-1">Vehicle Type/ Carrying Capacity</label>
                    <div class="w-full flex items-center gap-3">
                        <el-select v-model="payload.vehicleType" placeholder="Select vehicle type">
                            <el-option v-for="vehicleType in fleets.fleets || []" :key="vehicleType.id"
                                :label="vehicleType.vehicletype + ' (' + vehicleType.vehicleNumber + ')'"
                                :value="vehicleType.id"
                                >
                            </el-option>
                        </el-select>
                    </div>
                </div>

                <div class="w-full md:w-[48%]">
                    <label class="mb-1">Plate Number</label>
                    <el-select v-model="payload.plateNumber" placeholder="Select fleet">
                        <el-option v-for="fleet in getplateNumber" :key="fleet.vehicleNumber"
                            :label="fleet.vehicleNumber" :value="fleet.id">
                        </el-option>
                    </el-select>
                    <p class="driver_details">
                        Driver: {{ driverName }}
                    </p>
                </div>
            </div>

            <div class="mt-5 w-full md:w-6/12">
                <label>Upload Documents</label>
                <div :style="{
                    'background-color': '#FBFCFE',
                    border: '1px solid #DAE8F6',
                }" class="pt-2 px-3 rounded-lg overflow-hidden flex justify-between pb-2 w-full">
                    <div :style="{ color: '#B7BDCD', fontSize: '16px' }" class="mt-1 w-9/12">
                        <p v-if="!isUploadingDoc && !docUploaded">Upload File</p>
                        <div v-if="isUploadingDoc" class="d-flex justify-content-center py-2 -mt-2">
                            <saving-loader :icon-color="'#0253B3'" />
                        </div>
                    </div>

                    <button @click="triggerUpload = true" :style="{
                        'background-color': '#CBE0F6',
                        height: '32px',
                        width: '91px',
                    }" class="rounded-lg w-3/12">
                        Upload
                    </button>
                </div>

                <div class="mt-3">
                    <div class="image_list" v-for="url in payload.documentUrl" :key="url">{{ url.substring(url.length -
                        20)
                        }}<button @click="removeImageUrl(url)">&#x2715;</button>
                    </div>
                </div>

                <document-upload hidden ref="documentUploader" @input="handleDocUpload($event)"
                    @closeTrigger="triggerUpload = false" @remove-image="removeImage" :docurl="docurl"
                    :triggerUpload="triggerUpload" :isUploadingImage="isUploadingDoc" />
            </div>

            <!-- <div class="mt-5">
                <div class="flex flex-no-wrap justify-between gap-2">
                    <p>Truck Capacity {{ " " }} </p>
                    <p v-if="fleetDetails != 'N.A'">
                        {{ calculateCapacity }}/{{ Number(fleetDetails.carriageCapacity) }} Tons
                    </p>
                </div>
                <div class="flex flex-row-reverse h-[17px] mt-4">
                    <div :style="{ 'background-color': '#D5F2EA' }" class="w-100 relative z-20 h-6 rounded-r-lg"
                        v-if="(calculateCapacity / Number(fleetDetails.carriageCapacity)) * 100 < 100"></div>
                    <div :style="{
                        'background-color': '#00C48C',
                        width:
                            fleetDetails != 'N.A'
                                ? (calculateCapacity / Number(fleetDetails.carriageCapacity)) *
                                100 +
                                '%'
                                : '0%',
                    }" class="h-6 relative z-10 rounded-l-lg"></div>
                </div>
            </div> -->
        </div>

        <div class="flex justify-between mt-5" style="height: 40px">
            <button class="h-full bg-charcoal text-white rounded font-semibold" style="width: 120px"
                @click="createConsolidation('consolidation-completed')">
                Complete
            </button>

            <div class="h-full">
                <button class="h-full font-semibold" style="width: 120px" @click="goBack">
                    Cancel
                </button>

                <primary-button class="h-full bg-primary-yellow rounded font-semibold" buttonText="Save"
                    :disabled="!canProceed" style="width: 120px" :loading="isLoading"
                    @click="createConsolidation('in-progress')" />

            </div>
        </div>
    </div>
</template>

<script>
import SavingLoader from "@/components/UI/ButtonSavingLoader";
import { orgId, userId } from "@/services/apiConfig.js"

export default {
    components: {
        SavingLoader
    },
    data() {
        return {
            locations: [],
            fleetForConsolidation: [],
            isUploadingDoc: false,
            triggerUpload: false,
            fileName: null,
            docUploaded: false,
            isLoading: false,
            docurl: "",
            fleets: [],
            vehicles: [],
            payload: {
                orgId: "",
                userId: "",
                origin: "",
                destination: "",
                vehicleType: "",
                plateNumber: "",
                driverName: "",
                destinationName: "",
                fleetId: "",
                documentUrl: [],
                consignees: [],
                status: "on-hold" // only needed for on hold
            },
        }
    },
    activated() {
        this.getConsolidationFleet();
        this.getAllLocations();
        this.getAllFleetsForConsolidation()
        this.getAllFleetsForConsolidation()
    },
    methods: {
        flattenArray(arr) {
            return (arr || []).flatMap(item =>
                item.fleets.map(fleet => ({
                    ...fleet,
                    type: item.type, // 👈 inject type
                }))
            );
        },
        async createConsolidation() {
            this.isLoading = true
            try {
                await this.$_newCreateConsolidation({
                    orgId: orgId(),
                    userId: userId(),
                    shippingServiceId: this.getSelcRoute,
                    shipmentIds: this.getSelcShipments,
                    fleetId: this.fleetDetails.id,
                    driverId: this.fleetDetails?.driverId,
                    vehicleType: this.fleetDetails?.vehicletype,
                    plateNumber: this.fleetDetails?.vehicleNumber,
                    documentUrl: this.payload.documentUrl,
                    origin: this.currentLocation?.id,
                    destinations: this.payload.destination
                })
                this.$store.dispatch('setNewConsolidationLevel', 4)
            } catch (error) {
                this.handleError(error)
            } finally{
                this.isLoading = false
            }
        },
        removeImageUrl(val) {
            this.payload.documentUrl = this.payload.documentUrl.filter(url => url != val)
        },
        goBack() {
            this.$store.dispatch('setNewConsolidationLevel', 2)
        },
        async getConsolidationFleet() {
            console.log("routes--with id", this.getSelcRouteStr)
            try {
                let response = await this.$_newGetConsolidationFleets({
                    shippingServiceId: this.getSelcRouteStr,
                    shipmentId: this.getSelcShipmentsStr
                });
                this.fleets = response?.data?.data
            } catch (error) {
                // ..code here
            }
        },
        async handleDocUpload(image) {
            this.isUploadingDoc = true;
            this.triggerUpload = false;
            this.fileName = image.name;
            this.docUploaded = false;

            try {
                let response = await this.updateDocument(image);
                this.docurl = response;
                this.payload.documentUrl.push(response);
                this.isUploadingDoc = false;
                this.docUploaded = true;
                this.generateToast("Document uploaded", "success");
            } catch (error) {
                this.handleError(error);
                this.isUploadingDoc = false;
            }
        },
        async getAllLocations() {
            try {
                const response = await this.$_getAllLocations();

                console.log("current-loacation-id", this.$store.getters);
                this.locations = response.data.data.locations.filter((item) => item.id !== this.currentLocation?.locationId);
            } catch (error) {
                this.handleError(error);
            }
        },
        async getAllFleetsForConsolidation() {
            try {
                const response = await this.$_getAllFleetsForConsolidation();
                this.fleetForConsolidation = response?.data?.data;
                console.log("old consolidation fleet", response?.data?.data)
            } catch (error) {
                this.handleError(error);
            }
        },
    },
    computed: {
        canProceed() {
            return this.fleetDetails?.id && this.payload.destination.length > 0 && this.payload.plateNumber
        },
        getplateNumber() {
            return [...this.fleets.fleets].filter((item) => item.id === this.payload.vehicleType)
        },
        getSelcShipments() {
            return this.$store.getters?.getNewConsolidationSelecetedShipment
        },
        getSelcShipmentsStr() {
            return this.$store.getters?.getNewConsolidationSelecetedShipment.join(',')
        },
        getSelcRoute() {
            return this.$store.getters?.getNewConsolidationSelecetedRoute
        },
        getSelcRouteStr() {
            return this.$store.getters?.getNewConsolidationSelecetedRoute.join(',')
        },
        fleetDetails() {
            if (!this.payload.vehicleType) return "N.A";
            return this.fleets?.fleets.find((fleet) => fleet.id === this.payload.vehicleType);
        },
        currentLocation() {
            return this.$store.getters.currentLocation;
        },
        driverName() {
            return `${this.fleetDetails?.driver?.firstname || ""} ${this.fleetDetails?.driver?.lastname || ""}`;
        },
        filterFleetByType() {
            const typeFleets = this.fleetForConsolidation.find(item => item.type === this.payload.vehicleType)?.fleets || [];
            return typeFleets;
        },
        filterFleetByTypeTonnage() {
            const vehicleFleets = this.filterFleetByType.filter(item => item.capacity === this.fleetCapacity) || [];
            return vehicleFleets;
        },
    },
}
</script>

<style lang="scss" scoped>
.driver_details {
    @apply py-1 px-2 bg-primary-blue/5 w-full text-center
}

.image_list {
    @apply flex items-center justify-between w-full border border-gray-400/40 bg-primary-blue/5 px-2 py-2 mt-2
}

.places_wrapper {
    @apply w-full lg:w-[48%]
}

.tone_box {
    @apply w-[55px] h-[55px] bg-primary-yellow rounded-2xl inline-flex justify-center items-center
}

.tone_wrapper {
    @apply w-full sm:w-[300px] py-3 px-3 rounded-2xl border border-primary-yellow inline-flex gap-4 items-center bg-primary-yellow/10
}
</style>